const FeaturedTopicsContainer: React.FC = () => {
  return (
    <div className="featured-topics-container">
      <a href="/featured-topics" className="link-style">
        <h2 className="help-heading">Featured Topics</h2>
      </a>
      <div className="col">
        <a href="/featured-topics/tabs" className="link-style">
          <div className="topic-container">
            <h4>Tabs on the home page</h4>
            <p>
              There are seven tabs on the home page that link to different
              elements of the site...
            </p>
          </div>
        </a>
        <a href="/featured-topics/navigate" className="link-style">
          <div className="topic-container">
            <h4>How do I navigate the company panel?</h4>
            <p>
              On wider screens your screen will be split into the left side
              panel for the company metrics and the right side for the
              conversation channel...
            </p>
          </div>
        </a>
        <a href="/featured-topics/acronyms" className="link-style">
          <div className="topic-container">
            <h4>Acronyms used on CEO.CA</h4>
            <p>A more extensive glossary can be found here ...</p>
          </div>
        </a>
        <p style={{ marginTop: "3em", marginBottom: "2em" }}>
          <a
            href="/featured-topics"
            className="link-style"
            style={{ color: "darkblue", fontWeight: "500" }}
          >
            View all featured topics
          </a>
        </p>
      </div>
    </div>
  );
};

export default FeaturedTopicsContainer;
